import { render } from "./SSOActivate.vue?vue&type=template&id=35be09c2&scoped=true"
import script from "./SSOActivate.vue?vue&type=script&lang=js"
export * from "./SSOActivate.vue?vue&type=script&lang=js"

import "./SSOActivate.vue?vue&type=style&index=0&id=35be09c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35be09c2"]])

export default __exports__